import React from 'react';
import { MANUAL_EVALUATION } from 'Constants/General';
import { AutoEvaluationIcon, ManualEvaluationIcon } from 'Images';
import BasicTable from '../../../Components/BasicTable';
import useTranslation from '../../../Hooks/useTranslation';

const useEvaluation = (evaluation, employeesFilters, thereIsComponent, isLoading, confirmationRestartEvaluation) => {
  const { t2 } = useTranslation('CourseDetails');
  const lessonType = evaluation.LessonType.name;
  const icon = (
    <img
      src={lessonType === MANUAL_EVALUATION ? ManualEvaluationIcon : AutoEvaluationIcon}
      style={{ height: '100%' }}
    />
  );

  const typeLabel = lessonType === MANUAL_EVALUATION ? t2('ManualEvaluation') : t2('AutomaticEvaluation');

  const table =
    lessonType === MANUAL_EVALUATION ? (
      <BasicTable
        information={employeesFilters}
        thereIsComponent={thereIsComponent}
        headers={[t2('Name'), t2('Department'), t2('JobTitle'), t2('Terminal'), t2('Grade')]}
        limit={5}
        isLoading={isLoading}
      />
    ) : (
      <BasicTable
        information={employeesFilters}
        thereIsComponent={thereIsComponent}
        headers={[t2('Name'), t2('Department'), t2('JobTitle'), t2('Terminal'), t2('Grade')]}
        limit={5}
        isLoading={isLoading}
        restartButton
        restartButtonEvent={confirmationRestartEvaluation}
      />
    );

  return { icon, typeLabel, table };
};

export default useEvaluation;
